import { useAppointmentConfig } from "@/features/appointments/utils";
import { useActiveProject } from "@/features/project/ActiveProject";
import { type hfb as hfbType } from "@repo/api";
import { Option, Select } from "@repo/skapa";
import { FormField } from "@repo/skapa";
import { t } from "@repo/translation";
import { translateHFB, translateServices } from "@repo/ui";
import { useEffect } from "react";

export const DropinAppointmentForm = ({
  cmpCode,
  hfb,
  service,
  setCmpCode,
  setHfb,
  setService,
}: {
  cmpCode?: string;
  hfb?: hfbType;
  service?: string;
  setCmpCode: (code: string) => void;
  setHfb: (value: hfbType) => void;
  setService: (value?: string) => void;
}) => {
  const { opportunity } = useActiveProject();
  const defaultValues = {
    cmpCode: opportunity?.customerMeetingPointBuCode,
    hfb: opportunity?.hfb?.[0],
  };

  const { cmps, hfbs, services } = useAppointmentConfig(
    cmpCode ?? defaultValues.cmpCode,
    hfb ?? defaultValues.hfb
  );

  useEffect(() => {
    if (!cmpCode && defaultValues.cmpCode) {
      setCmpCode(defaultValues.cmpCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues.cmpCode]);

  useEffect(() => {
    if (hfb || !hfbs?.length) {
      return;
    }
    const defaultHfb = defaultValues.hfb;
    const validHfb =
      defaultHfb && hfbs.includes(defaultHfb) ? defaultHfb : hfbs[0];
    if (validHfb) {
      setHfb(validHfb);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hfb, hfbs?.[0], defaultValues.hfb]);

  useEffect(() => {
    if (!services?.length) {
      return;
    }
    if (!service || !services.includes(service)) {
      setService(services[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hfb, cmpCode, services?.[0], services?.length]);

  return (
    <>
      <FormField>
        <Select
          id="calendar-task-cmp-select"
          label={t("label.cmp")}
          value={cmpCode}
          required
          onChange={(e) => {
            setCmpCode(e.target.value);
            setService(undefined);
          }}
        >
          {cmps?.map((cmp) => (
            <Option
              key={cmp.unit_id_key}
              value={cmp.unit_id_key}
              name={`${cmp.name} ${cmp.unit_id_key ? `(${cmp.unit_id_key})` : ""}`}
            />
          ))}
        </Select>
      </FormField>
      <FormField>
        <Select
          id="calendar-task-service-type-select"
          label={t("label.department")}
          value={hfb}
          required
          onChange={(e) => {
            setHfb(e.target.value as any);
            setService(undefined);
          }}
        >
          {hfbs?.map((el) => (
            <Option key={`drop-in-${el}`} value={el} name={translateHFB(el)} />
          ))}
        </Select>
      </FormField>
      <FormField>
        <Select
          id="calendar-task-service-select"
          label={t("label.service")}
          value={service}
          required
          onChange={(e) => setService(e.target.value)}
        >
          {services?.map((el) => (
            <Option key={el} value={el} name={translateServices(el)} />
          ))}
        </Select>
      </FormField>
    </>
  );
};
